"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountCopySchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
exports.AccountCopySchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required(),
    intentId: yup_lib_1.default.string().required(),
    intentLevel: yup_lib_1.default.boolean().required(),
    message: yup_lib_1.default.string().required(),
    rule: yup_lib_1.default.object().when(['intentLevel'], {
        is: (intentLevel) => {
            return intentLevel === true;
        },
        then: yup_lib_1.default.object().nullable().notRequired(),
        otherwise: yup_lib_1.default.object().required()
    })
});
